<template>
  <div class="title-header">
    <h5>{{ breadcrumbs.title }}</h5>
  </div>
</template>

<script setup>
const props = defineProps({
  breadcrumbs: {
    type: Object,
    required: true,
  },
});
</script>

<style></style>
